import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { GetLeadsFromStorage, GetProcessList } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import { GetAllLeads, AddInteraction, MakeCall, GetAllInstitutes, AddInteractionForInstitute, GetInstituteTimeline, GetAgreementList } from '../../models/leads';
import { Filters } from '../Filters';
import { GetUserList } from '../../models/user';
import { AgreementsComp } from './agreements';
import { DownloadAgreement, GetAllAgreement } from '../../models/agreement';

export const Agreements = () => {
    const userData = useUserStore;
    const [openFilter, setOpenFilter] = useState(false);
    const [getAgreementList, setGetAgreementList] = useState(false);
    const [agreementList, setAgreementList] = useState([]);

    const [agreementSearchObj, setAgreementObj] = useState({});
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(50);
    const [totalRecords, setTotalRecords] = useState(0);

    const [interactionData, setInteractionData] = useState({});

    const [downloadObj, setDownloadObj] = useState({});
    const [downloadAgreement, setDownloadAgreement] = useState(false);
    const [downloadingAgreementId, setDownloadingAgreementId] = useState('');

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const [openInteractionBox, setOpenInteractionBox] = useState(false);

    const [statusListArray, setstatusListArray] = useState([]);
    const [getUserList, setGetUserList] = useState(false);
    const [userListData, setUserListData] = useState([]);

    const [addInteraction, setAddInteraction] = useState(false);

    const [getTimeline, setGetTimeline] = useState(false);
    const [timelineObj, setTimelineObj] = useState({});

    const [timelinePopup, setTimelinePopup] =
        useState(false);

    const [timelineData, setTimelineData] =
        useState([]);

    const navigate = useNavigate();


    const state = {
        userData: userData.getState(),
        getAgreementList: getAgreementList,
        agreementList: agreementList,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
        agreementSearchObj: agreementSearchObj,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        openInteractionBox: openInteractionBox,
        statusListArray: statusListArray,
        userListData: userListData,
        downloadingAgreementId
    }



    useEffect(() => {
        setAgreementObj({
            'set_no': setNo,
            'per_set': perSet,
        })
        setGetAgreementList(true);
    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setAgreementObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetAgreementList(true);
    };

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
        }, 2000)

    }

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setAgreementObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setAgreementObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetAgreementList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(50);
        setAgreementObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setAgreementObj((prev) => ({ ...prev, ['per_set']: 50 }));
    }

    const NavigateTo = (route) => {
        navigate('/' + route, { state: {} });
    }

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtCallBackDateTime') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 19).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtAgreementSearchName') {
            setAgreementObj((prev) => ({ ...prev, ['txtAgreementSearchName']: value }));
        }
        if (name === 'ddlLeadStatus') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatus']: value }));
        }
        if (name === 'txtInteractionDesc') {
            setInteractionData((prev) => ({ ...prev, ['txtInteractionDesc']: value }));
        }
        if (name === 'txtCallBackDateTime') {
            setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTime']: value }));
        }
        if (name === 'txtDeadReason') {
            setInteractionData((prev) => ({ ...prev, ['txtDeadReason']: value }));
        }
        if (name === 'ddlLeadDepartment') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartment']: value }));
            setGetUserList(true);
        }
        if (name === 'ddlLeadOwner') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadOwner']: value }));
        }
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const HandleGetAgreementListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res.data.agreementlistresponse.rows[0])
            setAgreementList(res.data.agreementlistresponse.rows)
            setTotalRecords(res.data.agreementlistresponse.metarow.totalRecordsInDb);
        }
        else {
            setAgreementList([]);
            setTotalRecords(0);
        }
        setGetAgreementList(false);
    }


    const ToggleFilter = () => {
        //  alert(openFilter);
        // userData.setState({ openFilter: true });
        if (openFilter === true) {
            setOpenFilter(false);
        }
        else {
            setOpenFilter(true);
        }
    }


    const SearchAgreementList = (type, searchData) => {
        console.log(searchData);
        if (type === 'reload') {
            setAgreementObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtAgreementSearchName': '',
            })
        }
        else if (type === 'direct') {
            setAgreementObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtAgreementSearchName': agreementSearchObj.txtAgreementSearchName,
            })
        }
        else {
            // alert('I am here');
            setAgreementObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtLeadSearchStartDate': searchData.txtLeadSearchStartDate,
                'txtLeadSearchEndDate': searchData.txtLeadSearchEndDate,
                'ddlGermanLevel': searchData.ddlGermanLevel,
                'ddlMaritalStatus': searchData.ddlMaritalStatus,
                'ddlLeadSearchStatus': searchData.ddlLeadSearchStatus,
                'txtSearchSalary': searchData.txtSearchSalary,
                'txtSearchInstitute': searchData.txtSearchInstitute,
            })

            ToggleFilter();
        }
        ResetPagination();
        setGetAgreementList(true);

    }

    const ToggleInteractionBox = () => {
        if (openInteractionBox == true) {
            setOpenInteractionBox(false);
        }
        else {
            setOpenInteractionBox(true);
        }
    }

    const DownloadAgreementPdf = (item) => {
        // console.log(leadData);
        setDownloadObj({
            'txtAgreementId': item._id,
        });
        console.log(downloadObj);
        setDownloadingAgreementId(item._id);

        setDownloadAgreement(true);
    }

    const HandleDownloadAgreementResponse = (res) => {
        setDownloadAgreement(false);
        setDownloadingAgreementId('');

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            //let downloadPath = res.data.downloadagreementresponse.message.value;
            setAlertMsg('Agreement Downloaded Successfully');
            const path = res.data.downloadagreementresponse.message.value;

            console.log('Original Path:', path);

            const fileName = path
                .split(/[\\/]/)
                .pop();

            console.log('File Name:', fileName);

            const fileUrl =
                'https://api.uprn.in/agreement/' + encodeURIComponent(fileName);

            console.log('File URL:', fileUrl);

            console.log('File URL:', fileUrl);
            window.open(fileUrl, "_blank", "noopener,noreferrer");

        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Agreement Download Failed');
        }

    }


    const AddNewInteraction = () => {
        if (interactionData.ddlLeadStatus == undefined || interactionData.ddlLeadStatus == null || interactionData.ddlLeadStatus.trim() == '') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: 'Please Select Status' }));
            return false;
        }
        else {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: '' }));
        }
        if (interactionData.ddlLeadStatus === 'Call Back') {
            if (interactionData.txtCallBackDateTime == undefined || interactionData.txtCallBackDateTime == null || interactionData.txtCallBackDateTime.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: 'Please Select Call Back Datetime' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'Onboarding') {
            if (interactionData.txtOnboardingDateTime == undefined || interactionData.txtOnboardingDateTime == null || interactionData.txtOnboardingDateTime.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtOnboardingDateTimeErr']: 'Please Select Call Back Datetime' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtOnboardingDateTimeErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'Dead') {
            if (interactionData.txtDeadReason == undefined || interactionData.txtDeadReason == null || interactionData.txtDeadReason.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: 'Please Enter Dead Reason' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'In Progress') {
            if (interactionData.ddlLeadDepartment == undefined || interactionData.ddlLeadDepartment == null || interactionData.ddlLeadDepartment.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: 'Please Select Department' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: '' }));
            }
            if (interactionData.ddlLeadOwner == undefined || interactionData.ddlLeadOwner == null || interactionData.ddlLeadOwner.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: 'Please Select Owner' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: '' }));
            }
        }
        setInteractionData((prev) => ({ ...prev, ['txtInstituteId']: downloadObj.txtInstituteId }));
        console.log(interactionData);
        // console.log(downloadObj);
        // call interaction api

        setAddInteraction(true);
    }




    const HandleInteractionSuccessResponse = (res) => {
        console.log(res);

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.interactionresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Interaction Not Added');
        }
        setInteractionData({});
        ToggleInteractionBox();
        setGetAgreementList(true);
        setAddInteraction(false);
    }

    const GetTimelineData = (institute_id) => {
        setTimelineObj({
            'instituteId': institute_id
        });
        setGetTimeline(true);
    }

    const HandleInstituteTimelineSuccessResponse = (res) => {
        setGetTimeline(false);
        if (res !== false) {
            console.log(res);
            let timelineData = res.data.timelineresponse.message.value;
            if (timelineData && timelineData.length > 0) {
                setTimelineData(
                    res.data.timelineresponse.message.value
                );
                setTimelinePopup(true);
            }
            else {
                setTimelineData(
                    []
                );
                setShowAlert(true);
                setAlertType('error')
                setAlertMsg('No Data Found');
            }

        }
        else {
            setTimelineData(
                []
            );
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('No Data Found');
            // setTimelinePopup(true);
        }

    }

    const CloseTimeLine = () => {
        setTimelinePopup(false);
    }

    return (
        <Box>
            {
                openFilter === true ?

                    <Filters ToggleFilter={ToggleFilter} type={'Agreement'} SearchList={SearchAgreementList} />

                    :
                    null
            }
            <AgreementsComp
                HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage}
                mystate={state}
                NavigateTo={NavigateTo}
                HandleInputs={HandleInputs}
                ToggleFilter={ToggleFilter}
                SearchAgreementList={SearchAgreementList}
                DownloadAgreementPdf={DownloadAgreementPdf}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                interactionData={interactionData}
                ToggleInteractionBox={ToggleInteractionBox}
                AddNewInteraction={AddNewInteraction}
                GetTimelineData={GetTimelineData}
                timelinePopup={timelinePopup}
                timelineData={timelineData}
                CloseTimeLine={CloseTimeLine}

            />
            {((getAgreementList === true) ? GetAllAgreement(pnkstore, agreementSearchObj, userData.getState().token, HandleGetAgreementListSuccessResponse) : "")}
            {((downloadAgreement === true) ? DownloadAgreement(pnkstore, downloadObj, userData.getState().token, HandleDownloadAgreementResponse) : "")}
        </Box>
    )
}